export const COUNT_INTRODUCTION_TEXT = {
  testCaption: "Проверка скорости чтения",
  testIntroductionPart1: "Как быстро читает ваш ребенок? А как быстро читаете вы?",
  testIntroductionPart2: "Тест позволит определить количество знаков в минуту, степень внимательности и процент информации, оставшейся в  памяти после прочтения.",
  nameLabel: "Ваше имя",
  namePlaceholder: "Введите ваше имя",
  ageLabel: "Ваш возраст",
};

export const CountDescriptionText = {
  instructionText: "ИНСТРУКЦИЯ",
  testDescription: [
    "Вам будет предложен небольшой отрывок из текста",
    "Прочитайте его как можно быстрее и ответьте на вопросы после прочтения",
    "Время чтения будет отражено на секундомере",
  ],
  gameStartText: "НАЧАТЬ!",
};

export const DISPLAY_WINDOW = {
  INTRODUCTION: "introduction",
  TASK: "task",
  QUESTIONS: "questions",
  RESULT: "result",
};

export const TASK_READ_TEXT = {
  textIsRead: "ПРОЧИТАНО",
  authorText: "Автор",
  authorUnknown: "без имени",
}

export const QUESTION_READ_TEXT = [
  "Чтение",
  "Вопросы",
  "Результат",
];

export const QUESTION_TASK_TEXT = {
  title: "Вопросы по тексту",
  getResult: "УЗНАТЬ РЕЗУЛЬТАТ",
};

export const RESULT_TEXT = {
  goodResultTitle: "Потрясающе!",
  decentResultTitle: "Ты можешь лучше!",
  yourResultText: "Ваш результат",
  wordsPerMinuteText: "слов в минуту!",
  understoodPercentageText: "Процент понятого текста",
  signsInText: "Знаков в тексте",
  readingTimeText: "Время чтения",
  ageCategoryText: "Возрастная категория",
  assumingTitle: "Хотите читать быстрее?",
  assumingDescription: "Наши ученики улучшают свои результаты на 60% от начальных навыков",
  submitFreeLessonText: "ЗАПИСАТЬСЯ НА БЕСПЛАТНЫЙ УРОК",
  shareResultText: "ПОДЕЛИТЬСЯ РЕЗУЛЬТАТОМ",
  tellFriendsText: "РАССКАЗАТЬ ДРУЗЬЯМ",
  hoursText: "ч",
  minutesText: "мин",
  secondsText: "сек",
  restartTest: "ПРОЙТИ ТЕСТ ЗАНОВО",
  shareGoodTitleText: "Я читаю со скоростью %% слов в минуту",
  shareDecentTitleText: "Ты знаешь свою скорость чтения?",
  shareGoodDescriptionText: "А какая скорость чтения у тебя? Пройди тест, давай посоревнуемся!",
  shareDecentDescriptionText: "Пройди тест, узнай на что ты способен!",
  noNameEntered: "Без имени"
};

export const INITIAL_STATE = {
  stage: DISPLAY_WINDOW.INTRODUCTION,
  name: '',
  loading: false,
  taskText: null,
  ageValue: 1,
  timer: {
    seconds: 0,
    minutes: 0,
    hours: 0,
  },
  answersPicked: [],
}

const AGE_DATA = [
  {
    value: 1,
    text: "8-9 лет",
  },
  {
    value: 2,
    text: "10-12 лет",
  },
  {
    value: 3,
    text: "13-15 лет",
  },
  {
    value: 4,
    text: "16 и старше",
  },
];

export default AGE_DATA;
